import React from "react";
import MaterialTable from "material-table";
import { Api } from "../../utils/api";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";

export default class EntityPlansTable extends React.Component {
  state = {
    columns: [
      { title: "", field: "id", hidden: true },
      { title: "", field: "entity_id", hidden: true },
      {
        title: "Plano",
        field: "plan_id",
        lookup: { 1: "Base", 2: "Standard", 3: "Premium", 4: "Avançado" },
      },
      {
        title: "Data Início",
        field: "started_at",
        type: "date",
        render: (rowData) => {
          return rowData.started_at
            ? moment(rowData.started_at).format("DD-MM-YYYY")
            : "";
        },
      },
      {
        title: "Data Fim",
        field: "ended_at",
        type: "date",
        render: (rowData) => {
          return rowData.ended_at
            ? moment(rowData.ended_at).format("DD-MM-YYYY")
            : "";
        },
      },
      {
        title: "Activo",
        field: "active",
        type: "boolean",
        render: (rowData) => {
          return rowData.active ? "Sim" : "Não";
        },
      },
      {
        title: "Ordem 'Premium'",
        field: "top_order",
        type: "boolean",
        render: (rowData) => {
          return rowData.top_order ? "Sim" : "Não";
        },
        editComponent: (props) => (
          <Checkbox
            value={props.value}
            onChange={(e) => props.onChange(e.target.checked)}
            disabled={props.rowData.plan_id !== 4}
            checked={props.value}
          />
        ),
      },
    ],
  };

  constructor() {
    super();
    this.api = new Api();
    this.goTo = this.goTo.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  refreshPage() {
    window.location.reload();
  }

  render() {
    const { plans } = this.props;
    const onUpdate = this.props.handleUpdate;
    const onDelete = this.props.handleDelete;

    return (
      <MaterialTable
        title=""
        columns={this.state.columns}
        data={plans}
        options={{ rowStyle: { backgroundColor: "#EEE" } }}
        editable={{
          //onRowAdd: newData => {
          //newData.entity_id = this.props.entity_id;
          //onAdd(newData).then(()=>{
          //this.refreshPage();
          //});
          //},
          onRowUpdate: (newData, oldData) => {
            newData.entity_id = this.props.entity_id;
            onUpdate(newData).then(() => {
              this.refreshPage();
            });
          },
          onRowDelete: (oldData) => {
            oldData.entity_id = this.props.entity_id;
            onDelete(oldData).then(() => {
              this.refreshPage();
            });
          },
        }}
      />
    );
  }
}
